import { mergeRight } from 'ramda';
import { ConfigComponent, ConfigElement } from '../_types';
import { emptyScreenTemplate } from '../templates/empty-screen';
import { ScreenProps } from '../../components-common/_types';
import { mapDashboardScreen, mapScreenBase } from '../templates/specs';
import { mapCreateScreen, mapEditScreen, mapIndexScreen } from './specs';
import { getTemplate } from '../templates/utils';
import { safeMerge } from '../../components-common/_utils';
import { TemplateTransformer } from '../_types/template-transformer';
import { TemplateType } from '@components-fabric/types';
import { mapUnderDevScreen } from './specs/screen.under-development';
import { mapEditTabScreen } from './specs/screen.edit.tab';
import { mapTabbedScreen } from './specs/screen.tabbed';

const templateTransforms: { [key in TemplateType]: TemplateTransformer[] } = {
  basic: [mapScreenBase],
  custom: [mapScreenBase],
  index: [mapScreenBase, mapIndexScreen as any],
  create: [mapScreenBase, mapCreateScreen as any],
  edit: [mapScreenBase, mapEditScreen as any],
  index_table: [mapScreenBase, mapIndexScreen as any],
  dashboard: [mapScreenBase, mapDashboardScreen as any],
  under_development: [mapScreenBase, mapUnderDevScreen as any],
  edit_tabbed: [mapScreenBase, mapEditTabScreen as any],
  tabbed: [mapScreenBase, mapTabbedScreen as any],
};

const mergeTransforms =
  (spec: TemplateTransformer) =>
  (data: Partial<ConfigElement>, context: ScreenProps) => {
    return mergeRight(data, spec(data as any, context));
  };

const createPipe = (initialContext: any, ...funcs: any[]) => {
  return (input: any) => {
    // Apply the first spec
    let result = funcs[0](input);

    // Apply the remaining specs
    let toMerge = result;
    for (let i = 1; i < funcs.length; i++) {
      result = funcs[i](input, toMerge);
      toMerge = safeMerge(toMerge, result);
    }

    return toMerge;
  };
};

// Applying the function conditionally
const executeTransformations = (element: ConfigElement, context: any) => {
  const templateSpecs =
    templateTransforms[getTemplate(element as any)] ??
    templateTransforms['custom'];

  const create = createPipe(emptyScreenTemplate, ...templateSpecs);

  const result = create(element);

  return result;
};

export const createPipeline = () => {
  return {
    transform: (element: ConfigComponent) => {
      const templateSpec = executeTransformations(element!, {});
      return templateSpec;
    },
  };
};
